module.exports = __webpack_public_path__ + "static/pic01-5c7e2a6a0f360bed48316fe0c430baef.jpg";